<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-autocomplete
          :style="isMobile ? 'width: 280px !important;' : ''"
          v-model="filters.name"
          :fetch-suggestions="querySearch"
          placeholder="姓名"
        ></el-autocomplete>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input v-model="filters.licenseid" placeholder="执业证书编码"></el-input>
      </el-form-item> -->
      <el-form-item label="">
        <el-autocomplete
          :style="isMobile ? 'width: 280px !important;' : ''"
          v-model="filters.HospitalName"
          :fetch-suggestions="querySearch1"
          placeholder="医院名称/任职机构"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="">
        <el-autocomplete
          :style="isMobile ? 'width: 280px !important;' : ''"
          v-model="filters.HCPID"
          :fetch-suggestions="querySearch2"
          placeholder="HCP ID"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="">
        <el-select :style="isMobile ? 'width: 280px !important;' : ''" v-model="filters.isexpiry" clearable placeholder="讲者协议是否有效">
          <el-option label="有效" :value="true"></el-option>
          <el-option label="无效" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select :style="isMobile ? 'width: 280px !important;' : ''" v-model="filters.status" clearable placeholder="审批状态">
          <el-option label="审批通过" :value="0"></el-option>
          <el-option label="审批中" :value="1"></el-option>
          <el-option label="审批驳回" :value="-1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select :style="isMobile ? 'width: 280px !important;' : ''" v-model="filters.hco_type" clearable placeholder="HCP类型">
          <el-option label="讲者" value="讲者"></el-option>
          <el-option label="术者" value="术者"></el-option>
          <el-option label="参会医生" value="参会医生"></el-option>
          <el-option label="拜访医生" value="拜访医生"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select :style="isMobile ? 'width: 280px !important;' : ''" v-model="filters.hcp_source" clearable placeholder="数据来源">
          <el-option v-for="value in HCPSource_list" :label="value" :value="value"></el-option>
        </el-select>
      </el-form-item>
      <div v-if="isMobile"></div>
      <!-- <el-form-item label="医院编码">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          v-if="!isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->

          <!-- <el-table-column sortable type="index" width="80" label="序号"></el-table-column> -->
          <el-table-column type="index" width="60">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                序号
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column sortable
        prop="remark"
        label="备注"
        width

      ></el-table-column> -->
          <el-table-column sortable prop="HCPID" label="HCP ID" width="160"></el-table-column>
          <el-table-column sortable prop="Name" label="姓名" width="100"></el-table-column>
          <el-table-column sortable prop="Gender" label="性别" width="80"></el-table-column>
          <el-table-column sortable prop="stair_departments_id_Name" label="部门" width="120"></el-table-column>
          <el-table-column sortable prop="second_departments_id_Name" label="科室" width="150"></el-table-column>
          <el-table-column sortable prop="bwacctnumber" label="ZCN" width="140"></el-table-column>
          <el-table-column sortable prop="HospitalName" label="医院名称/任职机构" min-width="220"></el-table-column>
          <el-table-column sortable prop="province_name" label="省份" min-width="140"></el-table-column>
          <!-- <el-table-column sortable prop="province_name" label="省份" width=""></el-table-column> -->
          <el-table-column prop="city_name" label="城市" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0; height: 34px; display: inline-block; line-height: 32px">
                城市
                <i @click="cp_zk_click" style="cursor: pointer" :class="HCO_LIST_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
            </template>
          </el-table-column>
          <!-- <div v-if="HCO_LIST_IF"> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="InformedConsent" label="知情同意书签署" width="150">
            <template scope="scope">{{ scope.row.InformedConsent == true ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="LicenseID" label="执业证书编码" width="160"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="Title" label="职称"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="menber_society" label="学会委员" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="education_background" label="教育背景" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="worke_xperience" label="工作/专业经历" width="160"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="Publications" label="发表文章" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="Level" label="评级" width="120"></el-table-column>
          <!-- </div> -->
          <el-table-column sortable prop="Source" label="数据来源" min-width="180"></el-table-column>
          <el-table-column sortable prop="status" label="审批状态" width="110">
            <template scope="scope">
              <el-tag :type="scope.row.status == 0 ? 'success' : scope.row.status == 1 ? 'warning' : 'danger'">
                {{
                  scope.row.status == 0 ? '审批通过' : scope.row.status == 1 ? '审批中' : scope.row.approval_cancel_is == true ? '撤回' : '审批驳回'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column sortable prop="business_life" label="验证状态" width="110">
            <template scope="scope">
              <el-tag :type="scope.row.CheckStatus == 1 ? 'warning' : scope.row.CheckStatus == 2 ? 'success' : 'danger'">
                {{ scope.row.CheckStatus == 1 ? '未验证' : scope.row.CheckStatus == 2 ? '验证通过' : '未通过' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="360">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-tickets"></i>
                详情
              </el-link>
              <el-link type="primary" v-if="EDIT_IF && (scope.row.status == 0 || scope.row.status == -1)" @click="handleEdit(scope.row.ID)">
                &nbsp;|&nbsp;
                <i class="el-icon-edit"></i>
                编辑
              </el-link>
              <el-link
                type="primary"
                v-if="YXQ_IF && (scope.row.status == 0 || scope.row.status == -1) && scope.row.CheckStatus == 2"
                @click="handleEdit(scope.row.ID, 'YXQ')"
              >
                &nbsp;|&nbsp;
                <i class="el-icon-edit"></i>
                更新有效期
              </el-link>
              <el-link type="danger" v-if="EDIT_IF && scope.row.approval_cancel" @click="handleRefresh(scope.row)">
                &nbsp;|&nbsp;
                <i class="el-icon-refresh-left"></i>
                撤回申请
              </el-link>

              <!-- <el-link
            type="primary"
            v-if="edit_if && scope.row.progress=='申请中'"
            @click="handleWithdraw(scope.row.id)"
          >
          |  撤回 </el-link
          > -->
              <!-- <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <el-table
          v-if="isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->

          <!-- <el-table-column sortable type="index" width="80" label="序号"></el-table-column> -->
          <el-table-column label="操作" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-tickets"></i>
                详情
              </el-link>
              <el-link type="primary" v-if="EDIT_IF && (scope.row.status == 0 || scope.row.status == -1)" @click="handleEdit(scope.row.ID)">
                &nbsp;|&nbsp;
                <i class="el-icon-edit"></i>
                编辑
              </el-link>
              <el-link
                type="primary"
                v-if="YXQ_IF && (scope.row.status == 0 || scope.row.status == -1) && scope.row.CheckStatus == 2"
                @click="handleEdit(scope.row.ID, 'YXQ')"
              >
                &nbsp;|&nbsp;
                <i class="el-icon-edit"></i>
                更新有效期
              </el-link>
              <el-link type="danger" v-if="EDIT_IF && scope.row.approval_cancel" @click="handleRefresh(scope.row)">
                &nbsp;|&nbsp;
                <i class="el-icon-refresh-left"></i>
                撤回申请
              </el-link>

              <!-- <el-link
            type="primary"
            v-if="edit_if && scope.row.progress=='申请中'"
            @click="handleWithdraw(scope.row.id)"
          >
          |  撤回 </el-link
          > -->
              <!-- <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
          <!-- <el-table-column sortable
        prop="remark"
        label="备注"
        width

      ></el-table-column> -->
          <el-table-column sortable prop="Name" label="姓名" width="100"></el-table-column>
          <el-table-column sortable prop="HospitalName" label="医院名称/任职机构" min-width="220"></el-table-column>
          <el-table-column sortable prop="HCPID" label="HCP ID" width="160"></el-table-column>
          <el-table-column sortable prop="Gender" label="性别" width="80"></el-table-column>
          <el-table-column sortable prop="stair_departments_id_Name" label="部门" width="120"></el-table-column>
          <el-table-column sortable prop="second_departments_id_Name" label="科室" width="150"></el-table-column>
          <el-table-column sortable prop="bwacctnumber" label="ZCN" width="140"></el-table-column>
          <el-table-column sortable prop="province_name" label="省份" min-width="140"></el-table-column>
          <!-- <el-table-column sortable prop="province_name" label="省份" width=""></el-table-column> -->
          <el-table-column prop="city_name" label="城市" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0; height: 34px; display: inline-block; line-height: 32px">
                城市
                <i @click="cp_zk_click" style="cursor: pointer" :class="HCO_LIST_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
            </template>
          </el-table-column>
          <!-- <div v-if="HCO_LIST_IF"> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="InformedConsent" label="知情同意书签署" width="150">
            <template scope="scope">{{ scope.row.InformedConsent == true ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="LicenseID" label="执业证书编码" width="160"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="Title" label="职称"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="menber_society" label="学会委员" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="education_background" label="教育背景" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="worke_xperience" label="工作/专业经历" width="160"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="Publications" label="发表文章" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="Level" label="评级" width="120"></el-table-column>
          <!-- </div> -->
          <el-table-column sortable prop="Source" label="数据来源" min-width="260"></el-table-column>
          <el-table-column sortable prop="status" label="审批状态" width="110">
            <template scope="scope">
              <el-tag :type="scope.row.status == 0 ? 'success' : scope.row.status == 1 ? 'warning' : 'danger'">
                {{ scope.row.status == 0 ? '审批通过' : scope.row.status == 1 ? '审批中' : '审批驳回' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column sortable prop="business_life" label="验证状态" width="110">
            <template scope="scope">
              <el-tag :type="scope.row.CheckStatus == 1 ? 'warning' : scope.row.CheckStatus == 2 ? 'success' : 'danger'">
                {{ scope.row.CheckStatus == 1 ? '未验证' : scope.row.CheckStatus == 2 ? '验证通过' : '未通过' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :current-page="page"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  HcoQueryPage,
  HcpQueryPage,
  store_data_ExportStore,
  store_data_Reback_Store,
  HcpApprovalCancel,
  HcpHcpExportExcel,
  Hcp_Get_HCPSource,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      hcp_name_list: [],
      hcp_hco_list: [],
      hcp_id_list: [],
      tableHeight: 0,
      HCO_LIST_IF: false,
      SalesOperation_if: false,
      edit_if_2: false,
      YXQ_IF: false,
      EDIT_IF: false,
      buttonList: [],
      managercode_list: [],
      HCPSource_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
        isexpiry: '',
        name: '',
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    storage_data() {
      // hcp_name_list:[], name
      // hcp_hco_list:[],  HospitalName
      // hcp_id_list:[],  HCPID
      if (this.filters.name) {
        if (this.hcp_name_list.length == 15) {
          this.hcp_name_list.splice(14, 1)
        }
        for (var i in this.hcp_name_list) {
          if (this.hcp_name_list[i].value == this.filters.name) {
            this.hcp_name_list.splice(i, 1)
          }
        }
        this.hcp_name_list.unshift({
          value: this.filters.name,
        })
      }
      if (this.filters.HospitalName) {
        if (this.hcp_hco_list.length == 15) {
          this.hcp_hco_list.splice(14, 1)
        }
        for (var i in this.hcp_hco_list) {
          if (this.hcp_hco_list[i].value == this.filters.HospitalName) {
            this.hcp_hco_list.splice(i, 1)
          }
        }
        this.hcp_hco_list.unshift({
          value: this.filters.HospitalName,
        })
      }
      if (this.filters.HCPID) {
        if (this.hcp_id_list.length == 15) {
          this.hcp_id_list.splice(14, 1)
        }
        for (var i in this.hcp_id_list) {
          if (this.hcp_id_list[i].value == this.filters.HCPID) {
            this.hcp_id_list.splice(i, 1)
          }
        }
        this.hcp_id_list.unshift({
          value: this.filters.HCPID,
        })
      }

      //  var name_list = JSON.
      // JSON.parse
      // JSON.stringify
      localStorage.setItem('hcp_name_list', JSON.stringify(this.hcp_name_list))
      localStorage.setItem('hcp_hco_list', JSON.stringify(this.hcp_hco_list))
      localStorage.setItem('hcp_id_list', JSON.stringify(this.hcp_id_list))
      console.log(localStorage.getItem('name_list'))
    },
    querySearch(queryString, cb) {
      var restaurants = this.hcp_name_list
      console.log(this.hcp_name_list)
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    querySearch1(queryString, cb) {
      var restaurants = this.hcp_hco_list
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    querySearch2(queryString, cb) {
      var restaurants = this.hcp_id_list
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    HcpApprovalCancel_fn(row) {
      HcpApprovalCancel(row).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules_search()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleRefresh(row) {
      this.$confirm('确定撤回该申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.HcpApprovalCancel_fn(row)
        })
        .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          //   });
        })
    },
    cp_zk_click() {
      if (this.HCO_LIST_IF) {
        this.HCO_LIST_IF = false
      } else {
        this.HCO_LIST_IF = true
      }
    },
    ExportAccount() {
      let para = this.filters
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      HcpHcpExportExcel(para).then((res) => {
        loading.close()
        window.open('/api' + res.data.response)
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // 导出
    // ExportAccount() {
    //   // let para = this.filters
    //   let para = {};
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   store_data_ExportStore(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? '正常' : '未知'
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == '' ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd')
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.storage_data()
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      console.log(para)
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      HcpQueryPage(para).then((res) => {
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
      })
    },
    //删除
    handleDel(ids) {
      console.log(ids)
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          let para = { id: ids }
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules()
          })
        })
        .catch(() => {})
    },
    handleWithdraw(id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handledetails: function (e) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/HCP/HCP_details',
        query: {
          id: e.ID,
          approval_data_id: e.approval_data_id,
          type: 'CK',
          back_url: '/HCP/HCP_list',
          filters_list: this.filters,
        },
      })
    },
    handleAdd: function (ids, progress) {
      this.$router.push({
        path: '/HCP/HCP_details',
        query: {
          type: 'ADD',
          back_url: '/HCP/HCP_list',
        },
      })
    },
    //编辑
    handleEdit: function (ids, type) {
      // console.log(id)
      // return
      var types = 'EDIT'
      if (type == 'YXQ') {
        types = 'CK'
      }
      this.$router.push({
        path: '/HCP/HCP_details',
        query: {
          id: ids,
          type: types,
          status: type,
          back_url: '/HCP/HCP_list',
          filters_list: this.filters,
        },
      })
    },
    handledetails_SalesOperation: function (ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    //localStorage 存储数组对象的方法
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data))
    },

    //localStorage 获取数组对象的方法
    getObjArr(name) {
      return JSON.parse(window.localStorage.getItem(name))
    },
    details_tag(name) {
      var router_list = this.getObjArr('router')
      for (let i in router_list) {
        for (let s in router_list[i].children) {
          //  console.log(999)
          if (router_list[i].children[s].id == '175') {
            //  console.log(999)
            router_list[i].children[s].name = name
            router_list[i].children[s].meta.title = name
            console.log(router_list[i].children[s].name)
            this.saveObjArr('router', router_list)
            console.log(this.getObjArr('router'))
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list)
    },
    async Hcp_Get_HCPSource_fn() {
      const { data } = await Hcp_Get_HCPSource()
      this.HCPSource_list = data.response
    },
  },
  mounted() {
    this.Hcp_Get_HCPSource_fn()
    // localStorage.clear('hcp_name_list')
    // console.log(localStorage.getItem('hcp_name_list'))
    if (localStorage.getItem('hcp_name_list')) {
      this.hcp_name_list = JSON.parse(localStorage.getItem('hcp_name_list'))
    }
    if (localStorage.getItem('hcp_hco_list')) {
      this.hcp_hco_list = JSON.parse(localStorage.getItem('hcp_hco_list'))
    }
    if (localStorage.getItem('hcp_id_list')) {
      this.hcp_id_list = JSON.parse(localStorage.getItem('hcp_id_list'))
    }
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 460
        } else {
          this.tableHeight = window.innerHeight - 250
        }
      })
    })
    if (this.$route.query.que) {
      this.filters.isexpiry = false
    }
    //     console.log(this.$route.query.filters_list)
    //    console.log(this.filters)
    //    if(this.$route.query.filters_list.name){
    console.log(this.$route.query)
    if (this.$route.query.filters_list !== '[object Object]' && this.$route.query !== undefined) {
      console.log(this.$route.query)
      if ('filters_list' in this.$route.query && this.$route.query.filters_list) {
        console.log(this.$route.query)
        this.filters = this.$route.query.filters_list
      }
    }
    //     console.log(this.filters)

    //    }
    this.getModules()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)

    if (this.buttonList) {
      if (
        this.buttonList.filter(function (e) {
          return e.name == '编辑'
        }).length != 0
      ) {
        this.EDIT_IF = true
      }
      if (
        this.buttonList.filter(function (e) {
          return e.name == '更新框架协议有效期'
        }).length != 0
      ) {
        this.YXQ_IF = true
      }
      this.buttonList = this.buttonList.filter(function (e) {
        return e.name != '编辑' && e.name != '更新框架协议有效期'
      })
    }
  },
}
</script>

<style scoped></style>
